import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { ReceiptService } from '../../../../services/accounting/receipt.service';
import { NotyService } from '../../../../services/common/noty.service';
import { HttpClientService } from '../../../../services/common/http-client.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-receipt-index',
  templateUrl: './receipt-index.component.html',
  styleUrls: ['./receipt-index.component.scss']
})

export class ReceiptIndexComponent implements OnInit {

  bankAccountTotals: Array<any> = [];

  count: number;

  receipts: Array<any> = [];

  searchParams: any = {
    page: 1,
    per_page: 50,
    reversal: "hide_reversed",
    commit: "search"
  }

  searching: boolean = false;

  searchOptions: any = {
    order_by: [],
    order_direction: []
  };

  sidebarMaximized: boolean = true;

  sidebarOpen: boolean = false;

  total: number;

  totalForQuery: number;

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
  */
  routerEventsSubscription: Subscription;

  constructor(
    private httpClientService: HttpClientService,
    private receiptService: ReceiptService,
    private notyService: NotyService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService){
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.initialize();
    });
  }

  ngOnInit(): void {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.initialize();
  }

  ngOnDestroy() {
    this.routerEventsSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
  }

  @HostListener('window:scroll', ['$event'])
   window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
   window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  clearSearch() {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.searchParams = {
      page: 1,
      per_page: 50,
      reversal: "hide_reversed"
    }
    this.search();
  }

  initialize() {
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    this.receiptService.getSearchOptions().then(response_json =>{
      console.log("getSearchOptions", response_json);
      this.searchOptions = response_json;
      if(this.searchOptions && this.searchOptions.per_page)
        this.searchParams.per_page = this.searchOptions.per_page;
      this.search()
    }).catch(getSearchOptionsError=>{
      console.log("getSearchOptionsError", getSearchOptionsError);
    });
  }

  search(pageEvent: any = null, isSearching: boolean | null = false) {
    if (isSearching)
      this.searching = true;
    if (pageEvent) this.searchParams.page = pageEvent.page;
    this.receiptService.index(this.searchParams).then(response_json => {
      console.log("index", response_json);
      ({receipts: this.receipts, count: this.count, total: this.total, bank_account_totals: this.bankAccountTotals, total_for_query: this.totalForQuery} = response_json);
      if (isSearching)
        this.searching = false;
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.receiptService.url, this.searchParams);
      if(window.location.href != newPageUrl)
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch((indexError) =>{
      console.log("indexError", indexError);
      this.notyService.notify('Error loading receipts', 'error');
    })
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}
